import React from 'react';
import { SlDropdownMenu } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/input';
import { DynamicDownChevron } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/DynamicDownChevron';
import { useLibraryExport, ExportOptionId } from './hooks/useLibraryExport';
import { useSnackbar } from 'src/utils/Hooks';

const EXPORT_OPTIONS = [
  { id: 'exportAll', label: 'Export All' },
  { id: 'exportGenerated', label: 'Export Generated Content' },
  { id: 'exportCurrent', label: 'Export Current Content' },
  { id: 'exportUploaded', label: 'Export Uploaded Content' }
];

/**
 * Blue dropdown export button for the Library SubtabHeader.
 * Fetches all library records and exports to CSV based on the selected option.
 */
export const LibraryExportButton = () => {
  const { handleExport, isExporting } = useLibraryExport();
  const { showSnackbar } = useSnackbar();

  return (
    <SlDropdownMenu
      defaultLabel={isExporting ? 'Exporting...' : 'Export'}
      selectedId={null}
      options={EXPORT_OPTIONS}
      disabled={isExporting}
      onChange={(option) => {
        handleExport(option.id as ExportOptionId)
          .then(() => {
            showSnackbar({ type: 'success', message: 'Content exported successfully.' });
          })
          .catch((err) => {
            const message = err instanceof Error ? err.message : 'Failed to export content.';
            showSnackbar({ type: 'error', message });
          });
      }}
      buttonVariant="contained"
      shouldShowFullItemText
      customEndIcon={
        <DynamicDownChevron
          color="white"
          style={{ verticalAlign: 'bottom' }}
        />
      }
      slMenuProps={{ fixSelectedId: false }}
    />
  );
};
